import { Card } from 'antd';
import React, { useState, useEffect } from 'react';
import { backendURL } from "../Globals";

const getStatusColor = (available, total) => {
  if (total === -1) return '#722ed1';        // ilimitado → morado
  if (available === 0) return '#ff4d4f';     // agotado → rojo
  const ratio = available / total;
  if (ratio > 0.5) return '#52c41a';         // buena disponibilidad → verde
  if (ratio > 0.15) return '#fa8c16';        // media → naranja
  return '#ff4d4f';                          // baja → rojo
};

const AvailablesComponent = () => {
  const [asignados, setAsignados] = useState([]);
  const [currentDate, setCurrentDate] = useState("");
  const [error, setError] = useState(null);

  const getAsignados = async () => {
    try {
      const response = await fetch(`${backendURL}/assigned`, {
        method: "GET",
        headers: { "Content-Type": "application/json" }
      });
      if (response.ok) {
        const jsonData = await response.json();
        const maxYear = Math.max(...jsonData.map(item => item.year));
        setAsignados(jsonData.filter(item => item.year === maxYear));
      } else {
        setError((await response.json()).error);
      }
    } catch (err) {
      setError('Error fetching data');
    }
  };

  useEffect(() => {
    getAsignados();
    setCurrentDate(new Date().toLocaleDateString('es-ES', { day: 'numeric', month: 'long', year: 'numeric' }));
  }, []);

  if (error) return <div>Error: {error}</div>;

  const limitados = asignados
    .filter(a => a.apc_count !== -1)
    .map(a => ({
      title: a.editor,
      available: Math.max(0, a.apc_count - a.used_count),
      total: a.apc_count,
    }))
    .sort((a, b) => b.available - a.available);

  const ilimitados = asignados
    .filter(a => a.apc_count === -1)
    .map(a => ({ title: a.editor, available: 'Ilimitado', total: -1 }))
    .sort((a, b) => a.title.localeCompare(b.title));

  const sortedEditors = [...limitados, ...ilimitados];

  return (
    <div>
      {/* Header */}
      <div style={{ paddingTop: 28, paddingBottom: 4, textAlign: 'center', background: '#fafafa' }}>
        <div style={{
          fontSize: 22, fontWeight: 700, color: '#1a1a1a',
          letterSpacing: -0.3, lineHeight: 1.3,
          fontFamily: "'Inter','Segoe UI',sans-serif",
          padding: '0 24px',
        }}>
          APCs disponibles a {currentDate}
        </div>
        <div style={{ fontSize: 13, color: '#888', marginTop: 6, paddingBottom: 16 }}>
          Actualización a medida que se van aprobando las solicitudes de financiación
        </div>
      </div>

      <div style={{ padding: '32px 48px 48px', maxWidth: 1100, margin: '0 auto' }}>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(210px, 1fr))',
          gap: '20px',
        }}>
          {sortedEditors.map((e, i) => {
            const color = getStatusColor(e.available, e.total);
            const isIlimitado = e.total === -1;
            const isAgotado = !isIlimitado && e.available === 0;
            const pct = isIlimitado ? 100 : e.total > 0 ? Math.round((e.available / e.total) * 100) : 0;

            return (
              <Card
                key={i}
                bordered={false}
                style={{
                  borderRadius: 10,
                  boxShadow: '0 2px 10px rgba(0,0,0,0.08)',
                  borderLeft: `4px solid ${color}`,
                }}
                bodyStyle={{ padding: '16px 20px 14px' }}
              >
                {/* Publisher */}
                <div style={{
                  fontSize: 12, fontWeight: 700, color: '#999',
                  textTransform: 'uppercase', letterSpacing: '0.07em',
                  marginBottom: 10,
                }}>
                  {e.title}
                </div>

                {/* Value */}
                <div style={{
                  fontSize: isAgotado ? 18 : 34, fontWeight: 800, color, lineHeight: 1,
                  fontVariantNumeric: 'tabular-nums',
                }}>
                  {isAgotado ? 'AGOTADOS' : isIlimitado ? '∞' : e.available}
                </div>

                {/* Subtitle */}
                <div style={{ fontSize: 11.5, color: '#bbb', marginTop: 4 }}>
                  {isIlimitado && 'APCs ilimitados'}
                  {isAgotado && `0 de ${e.total} — agotados`}
                  {!isIlimitado && !isAgotado && `de ${e.total} APCs asignados`}
                </div>

                {/* Progress bar (solo limitados) */}
                {!isIlimitado && (
                  <div style={{
                    marginTop: 12, height: 4, borderRadius: 2,
                    background: '#f0f0f0', overflow: 'hidden',
                  }}>
                    <div style={{
                      height: '100%', width: `${pct}%`,
                      background: color, borderRadius: 2,
                    }} />
                  </div>
                )}
              </Card>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default AvailablesComponent;
